import {
  CREATE_TECHNICIAN,
  VIEW_TECHNICIAN,
  UPDATE_TECHNICIAN,
  DELETE_TECHNICIAN,
  LIST_OF_TECHNICIAN,
  GET_EXPERTISE_LIST,
} from "./ApiRoutes";
import { authData } from "./services";

export const createTechnician = async (data: object) => {
  const response = await authData.post(CREATE_TECHNICIAN, data);
  return response?.data;
};

export const updateTechnician = async (id: number, data: object) => {
  const response = await authData.put(`${UPDATE_TECHNICIAN}${id}`, data);
  return response?.data;
};

export const listOfTechnician = async (data: object) => {
  const response = await authData.post(LIST_OF_TECHNICIAN, data);
  return response?.data;
};

export const viewTechnician = async (id: number) => {
  const response = await authData.get(`${VIEW_TECHNICIAN}${id}`);
  return response?.data;
};

export const deleteTechnician = async (id: number) => {
  const response = await authData.delete(`${DELETE_TECHNICIAN}${id}`);
  return response?.data;
};

export const listOfExpertiseForSelectApi = async (data: object) => {
  const response = await authData.post(GET_EXPERTISE_LIST, data);
  return response?.data;
};
